import { render, staticRenderFns } from "./StockMovementAddNew.vue?vue&type=template&id=22acfc89&"
import script from "./StockMovementAddNew.vue?vue&type=script&lang=js&"
export * from "./StockMovementAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports